import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const CardLink = styled(Link)`
  text-decoration: none;
  display: block;
`;

export const CardArticle = styled.article`
  position: relative;
  width: var(--card-w, clamp(200px, 16.2vw, 310px));
  height: auto;
  min-height: 220px;
  display: block;
  cursor: pointer;
  overflow: hidden;
  &:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.35); border-radius: 10px; }
  @media (max-width: 600px) { width: 100%; height: auto; min-height: 200px; }
`;

export const TitleBar = styled.div`
  background-color: var(--card-title-color);
  border-radius: 8px 8px 0 0;
  border: 2px solid rgb(247 247 251);
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  color: var(--accent-color);
  font-size: 15px;
  font-weight: bold;
`;

export const TitleAvatar = styled.img`
  border-radius: 5px 0 0 0;
  vertical-align: middle;
  margin: 5px;
  width: 60%;
  height: auto;
  max-width: 60px;
  max-height: 39px;
  flex-shrink: 0;
`;

export const TitleText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 6px;
`;
export const VendidoRibbon = styled.div`
  position: absolute;
  top: 18px;
  right: -28px;
  width: 110px;
  background: #e74c3c;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
  padding: 4px 0;
  transform: rotate(45deg);
  z-index: 20;
  letter-spacing: 0.05em;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  pointer-events: none;
`;